<div class="position-arrow">
    <div class="arrow arrow-first"></div>
    <div class="arrow arrow-second"></div>
</div>